import { render } from "./GuideLayer.vue?vue&type=template&id=3becf732&scoped=true"
import script from "./GuideLayer.vue?vue&type=script&lang=js"
export * from "./GuideLayer.vue?vue&type=script&lang=js"

import "./GuideLayer.vue?vue&type=style&index=0&id=3becf732&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3becf732"]])

export default __exports__